export const OPEN_ADD_CUSTOMER_ADDRESS_MODAL = 'OPEN_ADD_CUSTOMER_ADDRESS_MODAL';
export const CLOSE_ADD_CUSTOMER_ADDRESS_MODAL = 'CLOSE_ADD_CUSTOMER_ADDRESS_MODAL';

function open() {
  return {
    type: OPEN_ADD_CUSTOMER_ADDRESS_MODAL
  };
}

function close() {
  return {
    type: CLOSE_ADD_CUSTOMER_ADDRESS_MODAL
  };
}

export function openAddCustomerAddressesModal() {
  return (dispatch) => {
    dispatch(open());
  };
}

export function closeAddCustomerAddressesModal() {
  return (dispatch) => {
    dispatch(close());
  };
}
